import { Box, Link, Paper, Typography, useTheme } from "@mui/material";
import React from "react";
import { useIsMobile } from "../hooks/useIsMobile";
import { useLocalization } from "../hooks/useLocalization";
import { useLogout } from "../hooks/useLogout";
import { Rw1LogoColored } from "../icons/RW1LogoColored";
import { Footer } from "./Footer";

export const Unauthorized: React.FC = () => {
  const { t } = useLocalization();
  const theme = useTheme();
  const isMobile = useIsMobile();
  const handleLogout = useLogout();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        width: "100%",
        height: "100%",
        overflow: "auto",
        userSelect: "none",
      }}
    >
      <Box
        sx={{
          height: "100%",
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.colors.grey,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            backgroundColor: theme.colors.defaultBackground,
            borderRadius: isMobile ? "0px" : "24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            maxHeight: isMobile ? "100%" : "552px",
            height: "552px",
            maxWidth: isMobile ? "100%" : "432px",
            padding: "48px",
            textAlign: "center",
            width: "100%",
          }}
        >
          <Rw1LogoColored height="40px" width="11rem" />

          <Box sx={{ my: "64px" }}>
            <Typography
              component="h1"
              sx={{ fontSize: "28px", fontWeight: "700", mb: 3 }}
              variant="h5"
            >
              {t("components.unauthorized.accessDenied")}
            </Typography>

            <Typography
              sx={{
                fontSize: "18px",
                lineHeight: "24px",
                letterSpacing: "0.24px",
              }}
              variant="body1"
            >
              {t("components.unauthorized.noPermissionMessage")}
              <br />
              <br />
              {t("components.unauthorized.contactAdminMessage")}
            </Typography>
          </Box>

          <Typography
            sx={{
              color: theme.colors.text[3],
              textAlign: "center",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "16px",
              letterSpacing: "0.24px",
            }}
          >
            {t("components.unauthorized.differentAccount")}{" "}
            <Link
              component="button"
              onClick={handleLogout}
              sx={{
                color: theme.colors.text[3],
                fontSize: "12px",
                fontWeight: 700,
                lineHeight: "16px",
                letterSpacing: "0.24px",
                textDecoration: "underline",
                verticalAlign: "baseline",
              }}
            >
              {t("components.unauthorized.signIn")}
            </Link>
          </Typography>
        </Paper>
      </Box>
      <Footer />
    </Box>
  );
};
